import { createUseStyles } from 'react-jss';

const phone = '@media (max-width: 480px)';

export const useStyles = createUseStyles({
  page: {
    minHeight: '100dvh',
    display: 'flex',
    flexDirection: 'column',
    padding: '32px 40px',
    paddingTop: 'calc(32px + env(safe-area-inset-top, 0px))',
    paddingRight: 'calc(40px + env(safe-area-inset-right, 0px))',
    paddingBottom: 'calc(32px + env(safe-area-inset-bottom, 0px))',
    paddingLeft: 'calc(40px + env(safe-area-inset-left, 0px))',
    background: '#f4f6f8',
    boxSizing: 'border-box',
    [phone]: {
      paddingTop: 'calc(12px + env(safe-area-inset-top, 0px))',
      paddingRight: 'calc(12px + env(safe-area-inset-right, 0px))',
      paddingBottom: 'calc(16px + env(safe-area-inset-bottom, 0px))',
      paddingLeft: 'calc(12px + env(safe-area-inset-left, 0px))',
    },
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 16,
    flexShrink: 0,
    [phone]: {
      flexDirection: 'column',
      alignItems: 'stretch',
      gap: 12,
    },
  },
  content: {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    paddingTop: 24,
    paddingBottom: 8,
    [phone]: {
      paddingTop: 16,
    },
  },
  headerActions: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    justifyContent: 'flex-end',
    gap: 12,
    [phone]: {
      justifyContent: 'stretch',
      '& > button': {
        flex: 1,
      },
    },
  },
  languageSection: {
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
    marginTop: 20,
  },
  languageToggle: {
    width: '100%',
    '& .MuiToggleButton-root': {
      flex: 1,
    },
  },
  card: {
    width: '100%',
    maxWidth: 480,
    padding: '28px 24px',
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
    marginTop: 20,
  },
  actions: {
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
    marginTop: 8,
  },
});
